module.exports = __webpack_public_path__ + "assets/img/title_6.e7f29063.png";